import { makeStyles } from '@mui/styles';

const useStyles: any = makeStyles((theme: any) => ({
  tableHead: {
    height: "45px"
  },
  headCells: {
    border: "none",
    borderBottom: "none",
    color: theme.tables.headerCell.color,
    fontWeight: theme.tables.headerCell.fontWeight,
    fontFamily: theme.tables.headerCell.fontFamily,
    lineHeight: theme.tables.headerCell.lineHeight,
    letterSpacing: theme.tables.headerCell.letterSpacing,
    backgroundColor: theme.tables.headerCell.backgroundColor,
    textTransform: theme.tables.headerCell.textTransform,
    height: 45,
    fontSize: 13
  },
  rowCell: {
    fontFamily: theme.tables.tableCell.fontFamily,
    color: theme.tables.tableCell.color,
    fontSize: theme.tables.tableCell.fontSize,
    padding: 8
  },
  paperPadding: {
    padding: "20px 21px",
    maxHeight: "calc(100% - 130px)",
    display: "flex",
    flexFlow: "column nowrap",
    minHeight: "250px"
  },
  connectButton: {
    borderRadius: "4px",
    background: theme.gradiants?.button || "linear-gradient(90deg, #3f51b5 0%, #2196f3 100%)",
    fontFamily: "Roboto",
    fontSize: "11px",
    fontWeight: 500,
    color: "#fdfdfe",
    textTransform: "uppercase",
    padding: "4px 12px",
    marginRight: "8px",
    minWidth: "auto",
    "&:hover": {
      opacity: 0.9,
    },
    "&.Mui-disabled": {
      background: "#e0e0e0",
      color: "#9e9e9e",
    }
  },
  connectLocallyButton: {
    borderRadius: "4px",
    border: `1px solid ${theme.palette?.primary?.main || "#3f51b5"}`,
    fontFamily: "Roboto",
    fontSize: "11px",
    fontWeight: 500,
    color: theme.palette?.primary?.main || "#3f51b5",
    textTransform: "uppercase",
    padding: "3px 11px",
    minWidth: "auto",
    "&:hover": {
      backgroundColor: "rgba(63, 81, 181, 0.04)",
    },
    "&.Mui-disabled": {
      border: "1px solid #e0e0e0",
      color: "#9e9e9e",
    }
  },
  statusText: {
    fontWeight: 600,
    fontSize: "13px",
    fontFamily: "Roboto",
  },
  noDataMessage: {
    padding: "20px",
    textAlign: "center",
    color: "#757575",
    fontFamily: "Roboto",
    fontSize: "14px",
  },
  inputRoot: {
    color: "white",
    fontFamily: "Roboto",
    fontSize: "13px",
    width: "300px",
    display: "flex",
    flexDirection: "row",
    height: "36px",
    borderRadius: "4px",
    padding: "0 15px",
    backgroundColor: "rgba(170, 162, 170, 0.3)",
    maxWidth: "70%",
    marginRight: "40px"
  },
  searchIcon: {
    transform: "scale(0.7)",
    color: "white",
  },
  closeIconStyle: {
    color: "white",
    padding: "7px",
    "& svg": {
      fontSize: "24px"
    }
  },
  loaderStyle: {
    color: theme.palette?.primary?.main || "#3f51b5",
  }
}));

export default useStyles;
